<template>
  <div class="feature">
    <div class="description">
      <!-- <img 
        :src="require('@/assets/ico/' + iconName + '.svg')" 
        class="icon"
      > -->
      <h3>{{ $t(title) }}</h3>
      <p>{{ $t(description) }}</p>
    </div>
    <div class="illustration">
      <img 
        v-if="imgFormat === 'png'"
        :src="require('@/assets/features/' + imgName + '.png')"
        :srcset="require('@/assets/features/' + imgName + '.png') + ' 1x, ' + require('@/assets/features/' + imgName + '@2x.png') + ' 2x'"
        :alt="title"
      >
      <img 
        v-if="imgFormat === 'svg'"
        :src="require('@/assets/features/' + imgName + '.svg')"
        :alt="title"
      >
    </div>
  </div>
</template>

<script>
export default {
    props: {
        title: String,
        description: String,
        iconName: String,
        imgName: String,
        imgFormat: String
    }
}
</script>

<style lang="scss" scoped>
.feature {

    display: flex;
    flex-direction: column-reverse;

    h3 {
        margin-bottom: 20px;
    }

    p {
        margin-bottom: 90px;
    }

    .illustration {
        margin-bottom: 30px;
        flex: 1;
        @include respond-above(md) {
            margin-bottom: 90px;
        }
    }

    .icon {
        margin-bottom: 20px;;
    }
    
    @include respond-below(md) {
        .icon {
            display: none;
        }
    }

    @include respond-above(md) {

        flex-direction: row;
        text-align: left;
        align-content: center;

        &:nth-child(even) {
            flex-direction: row-reverse;
            .description {
                padding-left: 90px;
            }
        }
        &:nth-child(odd) {
            .description {
                padding-right: 90px;
            }
        }

        &:last-of-type {
            div {
                margin-bottom: 0;
                p {
                    margin-bottom: 0;
                }
            }
        }        


        .description {
            width: 50%;
            align-self: center;
        }
        .illustration {
            width: 50%;
            text-align: center;
            align-self: center;
            img {
                object-fit: cover;
                height: 1%;
            }
        }
    }
}
</style>